import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Box, Pagination, PaginationItem } from "@mui/material";
import { useMemo, useState } from "react";

import type { ReactNode } from "react";

export const PaginationWrapper = <T extends unknown[]>({
  data,
  renderPage,
  itemsPerPage,
}: {
  data: T;
  renderPage: (data: T) => ReactNode;
  itemsPerPage: number;
}): ReactNode => {
  const [page, setPage] = useState(1);

  const totalPages = useMemo(
    () => Math.ceil(data.length / itemsPerPage),
    [data.length, itemsPerPage],
  );

  const displayPage = totalPages === 0 ? 1 : Math.min(page, totalPages);

  const pagedData = useMemo(() => {
    const startIndex = (displayPage - 1) * itemsPerPage;
    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    return data.slice(startIndex, startIndex + itemsPerPage) as T;
  }, [data, displayPage, itemsPerPage]);

  return (
    <>
      {renderPage(pagedData)}
      <Box
        alignItems="center"
        sx={{
          p: 2,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Pagination
          renderItem={(item) => (
            <PaginationItem
              data-testid={item.type === "page" ? `pagination-page-${item.page}` : undefined}
              slots={{ previous: ArrowBack, next: ArrowForward }}
              {...item}
            />
          )}
          count={totalPages}
          page={displayPage}
          onChange={(_, pageNum) => {
            setPage(pageNum);
          }}
        />
      </Box>
    </>
  );
};
